import CourseLibrary from "../components/dashboard/CourseLibrary";

export default function Courses() {
  return (
    <div className="w-full">
      <CourseLibrary />
    </div>
  );
}
